import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import { makeStyles } from 'tss-react/mui';
import { faqsPerTab } from '../constant';
import { Typography } from '@mui/material';
import getRandomHexValue from '@helpers/getRandomHexValue';
import AccordionPanel from '@components/UI/AccordionPanel';
import { RightColumn } from '../styles';
const useStyles = makeStyles()({
    helpComponent: {
        '> h2': {
            marginBottom: 10,
        },
    },
    listContainer: {
        display: 'grid',
        paddingInlineStart: '0px',
        listStyleType: 'none',
        gap: 20,
        marginTop: 20,
        '> li': {
            display: 'grid',
            backgroundColor: '#fff',
            padding: 5,
            borderRadius: 5,
            '.MuiAccordion-root, .MuiAccordionSummary-root, .MuiAccordionSummary-content': {
                minHeight: 'unset',
            },
            h4: {
                fontSize: 14,
                lineHeight: 1.4,
            },
            p: {
                fontSize: 14,
                paddingTop: 16,
                whiteSpace: 'pre-line',
                lineHeight: 1.5,
                margin: 0,
            },
        },
    },
});
const Help = () => {
    const { classes } = useStyles();
    const location = useLocation();
    const [openIndex, setOpenIndex] = useState(null);
    const isActive = useCallback((index) => openIndex === index, [openIndex]);
    const screenPathName = location.pathname.split('/')[2];
    const faqList = useMemo(() => {
        var _a;
        return ((_a = faqsPerTab === null || faqsPerTab === void 0 ? void 0 : faqsPerTab[screenPathName]) === null || _a === void 0 ? void 0 : _a.map((item) => ({
            ...item,
            id: getRandomHexValue(),
        }))) || [];
    }, [screenPathName]);
    if (faqList.length === 0) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(RightColumn, { isHelpSection: true, children: _jsxs("div", { className: classes.helpComponent, children: [_jsx(Typography, { component: "h2", fontSize: 18, fontWeight: 700, children: "Frequently asked questions" }), _jsx(Typography, { component: "p", fontSize: 14, children: "Questions we've got asked a lot!" }), _jsx("ul", { className: classes.listContainer, children: faqList.map((faq, index) => (_jsx("li", { children: _jsx(AccordionPanel, { expanded: isActive(index), onChange: () => setOpenIndex(isActive(index) ? null : index), heading: faq.question, content: _jsx("p", { dangerouslySetInnerHTML: {
                                    __html: faq.answer,
                                } }), contentId: "faq-answer", id: "faq-question" }) }, faq.id))) })] }) }));
};
export default Help;
